<div id="footerfilter">
<app-breadcrumb></app-breadcrumb>
</div>
<app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
</app-notification-message>
<div id="headerfilter">
<h2 class="ms-4 me-3 mt-0 mb-0 roboto-medium">Master Settings</h2>
<div class="d-flex ms-4">
  <h4 class="roboto text-danger text-bolder">
    Abnormal Event Tracking Dashboard
  </h4>
</div>
</div>
<!-- <div
  class="
    d-flex
    justify-content-between
    mt-0
    mb-3
    align-items-center
    icon-container
    ms-4
    me-4
  "
>
</div> -->

  

<div id="LIOS-grid" class="grid-agg px-4">
  <ag-grid-angular
    class="ag-theme-balham grid-items"
    (gridReady)="onGridReady($event)"
    (window:resize)="sizeToFit()"
    [rowHeight]="rowHeight"
    [animateRows]="true"
    [defaultColDef]="defaultColDef"
    [columnDefs]="columnDefs"
    [suppressCellFocus]="true"
    [context]="context"
    [pagination]="true"
    [paginationPageSize]="paginationPageSize"
    [suppressPaginationPanel]="true"
    [headerHeight]="40"
    [floatingFiltersHeight]="40"
    [icons]="icons"
    (paginationChanged)="onPaginationChanged()"
    [rowClassRules]="rowClassRules"
    (filterChanged)="onFilterChanged($event)"
    (modelUpdated)="onModelUpdated()" [theme]="'legacy'"
  >
  </ag-grid-angular>

  <div
    class="d-flex pagination px-0 align-items-center justify-content-between"
  >
    <div>
      <div>
        <label class="page-drpdwn-label mx-2">Records/Page: </label>
        <select (change)="onPageSizeChanged($event)" class="paginate_drpdwn">
          <option value="5">5</option>
          <option value="10" selected>10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value={{rowCount}}>ALL</option>
        </select>
      </div>
    </div>
    <div class="d-flex align-items-center gap-3 me-3">
      <div>Viewing Records</div>
      <img
        alt="go to first page"
        src="assets/images/Icon awesome-fast-forward.svg"
        width="10"
        (click)="goToFirstPage()"
        class="text-primary reverse firstPage"
        [ngClass]="{
          disable_icon: getCurrentPage() == true,
          enable_icon: getCurrentPage() != true
        }"
      />
      <img
        alt="go to previous page"
        src="assets/images/Icon metro-next.svg"
        (click)="goToPreviousPage()"
        class="text-primary reverse previousPage"
        [ngClass]="{
          disable_icon: getCurrentPage() == true,
          enable_icon: getCurrentPage() != true
        }"
      />
      <div>
        (
        <span class="value" id="lbCurrentPage"></span> -
        <span class="value" id="lbTotalPages"></span>)&nbsp; OF &nbsp;
        <span>{{ rowCount }}</span>
      </div>
      <img
        alt="go to next page"
        src="assets/images/Icon metro-next.svg"
        (click)="goToNexpage()"
        class="text-primary nextPage"
        [ngClass]="{'disable_icon':(isLastPage()== true || rowCount==0),
        'enable_icon':(isLastPage()!= true || rowCount>0)}"
      />
      <img
        alt="go to last page"
        src="assets/images/Icon awesome-fast-forward.svg"
        width="10"
        (click)="goToLastPage()"
        class="text-primary lastPage"
        [ngClass]="{'disable_icon':(isLastPage()== true || rowCount==0),
        'enable_icon':(isLastPage()!= true || rowCount>0)}"
      />
    </div>
  </div>
</div>
